// @ts-expect-error Lexxy does not have types
import { configure } from "@37signals/lexxy"
import DisableToolbarTooltipsExtension from "./disable_toolbar_tooltips_extension"
import CollapsibleToolbarExtension from "./collapsible_toolbar_extension"
import SaveButtonExtension from "./save_button_extension"

// The order matters: DisableToolbarTooltipsExtension goes last so it also covers the buttons added by the others
configure({
  global: { extensions: [CollapsibleToolbarExtension, SaveButtonExtension, DisableToolbarTooltipsExtension] },
  default: { save_button: false, collapsible_toolbar: false },
})
